import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ClaimOutcomeService {

  constructor(
    public apiService: ApiService
  ) { }  

  public workflowCatOverview(requestParam: {}): Observable<any> {
    return this.apiService.postService('workflow/category/overview',requestParam);
  }
}
